module.exports = __webpack_public_path__ + "static/media/angel-face-emoji-emoticon-emotion-face-smiley-svgrepo-com.30fedd9a.svg";